import { Attach20Regular, Send20Filled } from "@fluentui/react-icons";
import styled, { css } from "styled-components";

export const NotesWrapper = styled.div`
    display: flex;
    flex-direction: column-reverse;
    padding: 16px;
    width: 100%;
    height: 70vh;
    overflow: auto;
    gap: 12px;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    padding: 0px 8px 8px 8px;
    gap: 8px;
`;

export const NoteInput = styled.textarea`
  font-family: Segoe UI;
  width: 98%;
  padding: 0px 2px 7px 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskNoteInputText};
  align-self: center;
  height: 64px;
  background-color: ${(props) => props.theme.serviceDeskInputNoteBackground};
  outline: none;

  :empty:before {
    content: attr(placeholder);
    color: #999;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    transform: scale(0.875);
    transform-origin: 0 0;
  }
`;

export const NotesInputWrapper = styled.div`
  width: 100%;
  cursor: auto;
  background-color: ${(props) => props.theme.serviceDeskInputNoteBackground};
  display: flex;
  flex-direction: column;
  outline: none;
  max-height: 100px;
  z-index: 0;

  &:after {
    content: '';
    border-bottom: solid 2px ${(props) => props.theme.selectedDateBackground};    
    transform: scaleX(0);   
  }
  &:focus-within:after { transform: scaleX(1); transition: transform 250ms ease-in; }
`;

export const NotesButtonWrapper = styled.div`
    position: absolute;
    padding: 16px 20px 40px 20px;
    gap: 12px;
    background-color: ${(props) => props.theme.serviceDeskMobileFooterBackground};
    box-shadow: 0px -1.2px 3.6px 0px #0000001C;
    width: 100%;
    display: flex;
    justify-content: center;

`;

export const StyledIcon = css`
    color: ${(props) => props.theme.selectedDateBackground};
`;

export const AttachIcon = styled(Attach20Regular)`
    ${StyledIcon}
`;

export const SendIcon = styled(Send20Filled)`
    ${StyledIcon}
`;